<template>
  <v-layout fill-height column>
    <div class="question" v-html="ques[0]"></div>
    <div class="answer">
      <div class="body-content">
        <div class="body-area">
          <!-- 나중에 공통코드 추가/삭제시 화면도 같이 수정해야함 -->
          <!-- <BodyBg
            :heart="valueSet('심장/등')"
            :upperAbdomen="valueSet('상복부')"
            :lowerAbdomen="valueSet('하복부')"
            :thigh="valueSet('허벅지')"
            :knee="valueSet('무릎')"
            :calf="valueSet('종아리')"
            :feet="valueSet('발')"
            :head="valueSet('머리')"
            :eyes="valueSet('눈')"
            :nose="valueSet('코')"
            :mouth="valueSet('입')"
            :ear="valueSet('귀')"
            :neck="valueSet('목')"
            :shoulder="valueSet('어깨')"
            :arm="valueSet('팔')"
            :hands="valueSet('손')"
          /> -->
          <BodyBg
              :heart="valueSet(bodyData[0].replyCodeNm)"
              :upperAbdomen="valueSet(bodyData[1].replyCodeNm)"
              :lowerAbdomen="valueSet(bodyData[2].replyCodeNm)"
              :thigh="valueSet(bodyData[3].replyCodeNm)"
              :knee="valueSet(bodyData[4].replyCodeNm)"
              :calf="valueSet(bodyData[5].replyCodeNm)"
              :feet="valueSet(bodyData[6].replyCodeNm)"
              :head="valueSet(bodyData[8].replyCodeNm)"
              :eyes="valueSet(bodyData[9].replyCodeNm)"
              :nose="valueSet(bodyData[10].replyCodeNm)"
              :mouth="valueSet(bodyData[11].replyCodeNm)"
              :ear="valueSet(bodyData[12].replyCodeNm)"
              :neck="valueSet(bodyData[13].replyCodeNm)"
              :shoulder="valueSet(bodyData[14].replyCodeNm)"
              :arm="valueSet(bodyData[15].replyCodeNm)"
              :hands="valueSet(bodyData[16].replyCodeNm)"
          />
          <BodyLine class="body-line" v-if="valueSet(bodyData[7].replyCodeNm)" />
        </div>
        <div class="body-btns">
          <!-- 버튼 두줄로 만들어 주기 위해서 for문 두번..-->
          <div v-for="i in 2" :key="i" class="d-flex flex-column">
            <template v-if="i == 1">
              <v-btn
                  v-for="n in 8"
                  :key="n"
                  depressed
                  :class="{ active: bodyData[n - 1].value }"
                  @click="selectBody(n-1)"
              >{{ bodyData[n - 1].replyCodeNm }}
              </v-btn
              >
            </template>
            <template v-if="i == 2">
              <v-btn
                  v-for="n in (bodyData.length - 8)"
                  :key="n+8"
                  depressed
                  :class="{ active: bodyData[n + 7].value }"
                  @click="selectBody(n+7)"
              >{{ bodyData[n + 7].replyCodeNm }}
              </v-btn
              >
            </template>
          </div>
        </div>
      </div>
    </div>
    <v-footer app grow color="transparent" class="content-footer">
      <v-container class="pb-0">
        <v-checkbox v-model="notKnow"
                    :label="label"
                    :ripple="false"
                    :readonly="cmplt"
                    hide-details
                    class="checkbox-circle"
                    @change="checkboxChange"
        ></v-checkbox>
      </v-container>
      <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total" :disabledNext="disabledNext" />
    </v-footer>
  </v-layout>

</template>

<script>
import BodyBg from "@/components/solution/solutionBody/BodyBg";
import BodyLine from "@/components/solution/solutionBody/BodyLine";
import FooterBtnsNext from '@/components/btns/FooterBtnsNext'

import store from '../../../store'
export default {
  props:["current","total","unitUseNo","unitDtlUseList","freeYn","cmpltYn","unitDtlUseNo","unitDtlPageSeq"],
  // props:{
  //   current:Number,
  //   total:Number,
  // },
  data: () => ({
    notKnow: false,
    notKnowObj: '',
    label:'',
    disabledNext: true,
    free: 'N',
    cmplt:false,
    bodyData: [
      { replyCodeNm: "상복부", value: false },
      { replyCodeNm: "하복부", value: false },
      { replyCodeNm: "심장/등", value: false },
      { replyCodeNm: "허벅지", value: false },
      { replyCodeNm: "무릎", value: false },
      { replyCodeNm: "종아리", value: false },
      { replyCodeNm: "발", value: false },
      { replyCodeNm: "피부", value: false },
      { replyCodeNm: "머리", value: false },
      { replyCodeNm: "눈", value: false },
      { replyCodeNm: "코", value: false },
      { replyCodeNm: "입", value: false },
      { replyCodeNm: "귀", value: false },
      { replyCodeNm: "목", value: false },
      { replyCodeNm: "어깨", value: false },
      { replyCodeNm: "팔", value: false },
      { replyCodeNm: "손", value: false },
    ],
    // bodyData: [],
    bodySelect: [],
    ques:[],
    // replyArr:[], -- bodyData
    // replyObjArr:[], -- bodyData
    // userReplyNo:[],
    userReply:[],   // 유저 답변 저장
    // userReplyObj:[],  // 유저 답변 가져온값
  }),
  components: {
    BodyBg,
    BodyLine,
    FooterBtnsNext
  },
  computed: {
    filteredItems: function () {
      return this.bodyData.slice(0, 10);
    },
  },
  mounted () {
    this.getUnitDetailUse();
  },
  methods: {
    async getUnitDetailUse () {
        // 무료 여부
        this.free = this.freeYn
        // 완료 여부
        this.cmplt = this.cmpltYn

        await store.dispatch('getUnitDetailUse', this.$_payload('so',
            [{'unitUseNo': this.unitUseNo},
              {'unitDtlUseNo':this.unitDtlUseNo[this.current-1]},
              {'unitDtlPageSeq':this.unitDtlPageSeq[this.current-1]},
              {'freeYn':this.free},
              {'feedbackUserKey': this.$route.query.feedbackUserKey}
            ]))
            .then(res => {
            if (res.success) {

              // 질문 리스트
              res.data.unitDtlQuesList.forEach((quesEl) => {

                // 질문 셋팅
                // this.ques[i] = quesEl.ques
                this.ques.push(quesEl.ques)

                // 답변 셋팅
                this.bodyData.splice(0, this.bodyData.length);
                quesEl.unitDtlReplyList.forEach((replyEl) => {
                  // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                  if(replyEl.reply == '18'){
                    this.notKnowObj = replyEl
                    this.notKnow = false
                    this.label = replyEl.replyCodeNm
                  } else{
                    replyEl.memberUnitDtlReplyUseNo = 0
                    replyEl.value = false
                    this.bodyData.push(replyEl)
                  }

                });
                // 유저 답변 셋팅
                quesEl.memberUnitDtlReplyList.forEach((userReplyEl) => {

                  if(userReplyEl.reply == '18'){  //모르겠어요
                    this.notKnow = true
                    this.checkboxChange()
                  } else{
                    this.userReply.push(userReplyEl)
                    // this.userReplyObj.push(userReplyEl)

                    // 부위선택
                    var index = 0
                    if(userReplyEl.reply < 10){
                      index = userReplyEl.reply*10/10 -1
                    }else{
                      index = userReplyEl.reply -1
                    }
                    this.bodyData[index].value = !this.bodyData[index].value;

                    // 다음버튼 제어
                    if(this.userReply.length > 0){
                      this.disabledNext = false
                    } else{
                      this.disabledNext = true
                    }
                  }
                });
              });
            } else {
                console.log(res.msg)
                // this.answer = [];
            }
            })
            .catch(error => {
                console.error(error)
                // this.answer = [];
            })
            .finally(() => {})
    },
    async setMemberReply () {

      if(!this.cmplt){ // 완료상태가 아닐때만 저장
        // 답변 객체
        this.userReply.forEach((obj) => {
            obj.memberUnitDtlReplyUseNo = 0,
            obj.userKey = this.$store.state.auth.authUser.userKey,
            obj.freeYn  = this.free
            obj.unitType  = "01"
        });

        // 모르겠어요 선택시
        if(this.notKnow){
          this.notKnowObj.memberUnitDtlReplyUseNo = 0,
          this.notKnowObj.userKey = this.$store.state.auth.authUser.userKey,
          this.notKnowObj.freeYn  = this.free
          this.notKnowObj.unitType  = "01"

          this.userReply.push(this.notKnowObj)
        }

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList',this.userReply))
              .then(res => {
                if (res.success) {
                    setTimeout(() => this.$emit('next'), 500); // 저장한 이후
                } else {
                    console.log(res.msg)
                }
              })
              .catch(error => {
                console.error(error)
              })
              .finally(() => {
              })
      } else {
        this.$emit('next')
      }
    },
    valueSet(name) {
      let index = this.bodyData.findIndex((item) => {
        return item.replyCodeNm === name;
      });
      return this.bodyData[index].value;
    },
    selectBody(index){
      // 미완료시에 동작
      if(!this.cmplt){
        this.notKnow = false;
        this.bodyData[index].value = !this.bodyData[index].value;

        if(this.bodyData[index].value){
          // this.userReplyObj.forEach((obj) => {
          //   if(obj.reply == this.bodyData[index].reply){
          //     this.bodyData[index].memberUnitDtlReplyUseNo = obj.memberUnitDtlReplyUseNo
          //   }
          // });
          this.userReply.push(this.bodyData[index])
          this.userReply.sort(function(a, b) { return a.reply - b.reply; }) // 배열에 담은 이후 코드값 정렬
        } else {
          for(let i = 0; i < this.userReply.length; i++) {
            if(this.userReply[i].reply === this.bodyData[index].reply)  {
              this.userReply.splice(i, 1);
              i--;
            }
          }
        }

        // 다음 버튼 제어
        if(this.userReply.length > 0){
          this.disabledNext = false
        } else{
          this.disabledNext = true
        }
      }
    },
    checkboxChange(){
      if(this.notKnow){
        this.bodyData.forEach((value, index) => {
          this.bodyData[index].value = false;
        });

        this.userReply.splice(0, this.userReply.length);
      }

      // 다음 버튼 제어
      if(this.notKnow){
        this.disabledNext = false
      } else{
        this.disabledNext = true
      }
    },
  },
};
</script>
